import React from "react";

import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { useFormikContext } from "formik";

import { ReactComponent as AlertSvg } from "assets/images/icons/caution.svg";
import ClosableDialog from "components/shared/ClosableDialog";
import { Para16Text } from "components/shared/Typography";
import { CUSTOM_PANELS } from "helpers/apis";
import useCatalogDetail from "hooks/useCatalogDetail";
import { ICustomPanelForm } from "types/form";
import { ICustomPanel } from "types/panel";

interface ICompareConfirmAlertProps {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export const CompareConfirmAlert: React.FC<ICompareConfirmAlertProps> = ({
  open,
  setOpen,
}) => {
  const { customPanelAction, draftSaved, setDraftAlertStatus, setDraftSaved } =
    useCatalogDetail();
  const { handleSubmit, isSubmitting, setFieldError, setSubmitting, values } =
    useFormikContext<ICustomPanelForm>();

  const onClose = () => {
    setOpen(false);
  };

  const handleSaveAndCompare = () => {
    customPanelAction({
      values: { ...values, status: "draft" },
      actions: { setFieldError, setSubmitting },
      callback: ({ data }: { data: ICustomPanel }) => {
        setDraftSaved(data);
        handleSubmit();
      },
      confirmed: undefined,
      errorCallback: () => {
        setDraftAlertStatus("error");
      },
      config: {
        url: `${CUSTOM_PANELS}${draftSaved!.id}`,
        method: "PUT",
      },
    });
  };

  return (
    <ClosableDialog maxWidth="sm" fullWidth open={open} onClose={onClose}>
      <DialogTitle>
        <Typography variant="h1" component="h2" align="center">
          Alert
        </Typography>
      </DialogTitle>

      <DialogContent>
        <Box mb={3} display="flex" justifyContent="center">
          <AlertSvg />
        </Box>
        <Para16Text align="center">
          You have unsaved changes. Would you like to Compare this panel without
          saving the current draft?
        </Para16Text>
      </DialogContent>

      <DialogActions>
        <Box
          display="flex"
          justifyContent="center"
          columnGap={2}
          pb={3}
          mt={-1}
          flex={1}
        >
          <Button
            onClick={() => {
              handleSubmit();
            }}
            size="large"
            disabled={isSubmitting}
          >
            Compare without saving
          </Button>
          <Button
            variant="outlined"
            size="large"
            disabled={isSubmitting}
            onClick={handleSaveAndCompare}
          >
            Save and compare
          </Button>
        </Box>
      </DialogActions>
    </ClosableDialog>
  );
};
